<template>
  <div class="primary--text">

    <!--    <p>-->
    <!--      https://medium.com/@vivekdhumal/how-to-make-a-video-recorder-using-videojs-record-vue-and-laravel-c586fed455bd-->
    <!--    </p>-->
    <v-row justify="center">
      <v-col cols="12">
        <v-alert
            type="error"
            color="red"
            v-if="error != null"
        >{{ error }}

          <v-btn outlined dark v-if="errorType=='Camera'" @click="$refs.videorecorder.resetPlayer()" class="ml-2">Retry</v-btn>
        </v-alert>

        <!--        <p class="headline">{{question}}</p>-->


        <VideoRecorder
            ref="videorecorder"
            @is-recording="changeRecording"
            @on-finished-recording="onFinisedRecording"
            @on-error="onError"
            @on-device-error="onDeviceError"
            @timestamp="onRecorderTimestamp"
        />
        <div class="text-center my-2" v-if="isRecording">Recording... ({{ timeRecordRemaining }}s)</div>
        <!--        <div class="text-center my-2" v-if="isRecording"><v-icon left style="color: #ff0000" class="heart">mdi-radiobox-marked</v-icon>Recording... ({{timeRecordRemaining}}s)</div>-->

        <div class="headline text-center my-5">{{ question }}</div>
        <div class="white--text text-center">You have 30 seconds for recording your video.</div>
      </v-col>
    </v-row>

    <v-row v-if="isUploading">
      <v-col>
        <v-progress-linear

            v-model="uploadPercentage"
            color="grey accent-4"
        ></v-progress-linear>
        <div>Uploading: {{ uploadPercentage }} %</div>

      </v-col>
    </v-row>


    <v-row justify="center" v-show="!isUploading">
      <v-btn x-large rounded outlined color="#000000" @click="$emit('cancel')" class="ma-2">Cancel</v-btn>
      <v-btn x-large rounded elevation="0" color="#ff0000" @click="startCountdown" v-if="!isRecording" class="ma-2 btnRecord">
        Record Video
      </v-btn>
      <v-btn x-large rounded elevation="0" color="#ff0000" @click="recordVideoStop" v-if="isRecording" class="ma-2">Stop
        Recording
      </v-btn>
      <v-btn v-if="!isRecording && recordedVideoFile" x-large rounded elevation="0" color="#84cde4"
             @click="$refs.videorecorder.playVideo()"
             class="ma-2 btnPlayVideo">Watch your Video
      </v-btn>
      <v-btn v-if="!isRecording && recordedVideoFile" x-large rounded elevation="0" color="#09b11c" @click="uploadVideo"
             class="ma-2 btnSaveAndUpload">Save & Send
        File
      </v-btn>
    </v-row>
    <!--    <v-row justify="center" v-if="!isRecording">-->
    <!--      <v-btn x-large rounded elevation="0" color="#84cde4" @click="$refs.videorecorder.playVideo()" v-if="recordedVideoFile"-->
    <!--             class="ma-2">Watch your Video-->
    <!--      </v-btn>-->
    <!--      <v-btn x-large rounded elevation="0" color="#09b11c" @click="uploadVideo" v-if="recordedVideoFile" class="ma-2">Save & Send-->
    <!--        File-->
    <!--      </v-btn>-->
    <!--    </v-row>-->
  </div>
</template>

<script>
// @ is an alias to /src
import VideoRecorder from "../components/recorder/VideoRecorder";
import {mapState} from 'vuex';
import {isMobile} from 'mobile-device-detect';

const fb = require('@/firebase/config.js');

export default {
  name: 'StepVideoDesktop',
  components: {
    VideoRecorder,
  },
  data: () => ({
    error: null,
    errorType: null,
    isRecording: false,
    videoRecorded: false,
    recordedVideo: null,
    uploadPercentage: 0,
    isUploading: false,
    choosenVideoFile: null,
    timeRecordRemaining: 0,
  }),
  // ...
  computed: {
    ...mapState({
      browserVideoRecordingSupport: state => state.browserVideoRecordingSupport,
      recordedVideoFile: state => state.recordedVideo,
      question: state => state.question,
      form: state => state.form
    }),
    ...mapState('user', {
      loggedin: state => state.loggedin,
      user: state => state.user,
      userClaims: state => state.claims,
    }),
    isMobileDevice() {
      return isMobile;
    }
  },
  methods: {

    startCountdown() {
      this.$refs.videorecorder.startCountdown();
    },

    changeRecording(args) {
      this.isRecording = args;
    },
    onError(args) {
      console.log('on Record ERROR', args);
      this.videoRecorded = false;
      this.recordedVideo = null;
      this.error = args;
    },
    onDeviceError(args) {
      console.log('on Device ERROR', args);
      this.videoRecorded = false;
      this.recordedVideo = null;

      this.errorType = 'Camera';
      this.error = "Camera Error: " + args.message;
    },
    onFinisedRecording(args) {
      console.log('on Record FINISHED', args);
      this.videoRecorded = true;
      this.recordedVideo = args;
      this.$store.commit('setVideoFile', args);
    },
    onRecorderTimestamp(args) {
      console.log("ts: ", args);
      this.timeRecordRemaining = args;
    },
    resetTimer() {
      console.log('Page Timer Reset');
      clearTimeout(this.pageTimer);
      this.startTimer();
    },

    recordVideoStop() {
      this.$refs.videorecorder.stopRecording();
    },

    uploadVideo() {
      var self = this;
      self.error = null;
      self.errorType = null;
      //this.player.record().saveAs({'video': 'my-video'});
      //https://github.com/collab-project/videojs-record/blob/master/examples/upload/fine-uploader.html
      //https://github.com/collab-project/videojs-record/blob/master/examples/upload/jquery.fileupload.html
      var videoFile = this.recordedVideoFile;
      console.log('finished recording: ', videoFile);
      console.log('finished recording, form: ', this.form);
      // upload data to server
      // var filesList = [videoFile];
      let formData = new FormData();
      //formData.append('filesList', filesList);

      const q = {
        uid: this.user.uid,
        question: this.question
      }

      formData.append('data', JSON.stringify({...this.form, ...q}));
      formData.append('sequenceId', this.sequenceId);
      formData.append('videoFile', videoFile, new Date().getTime() + '_video.webm');

      /*
        Make the request to the POST /select-files URL
      */
      this.isUploading = true;
      // this.$http.post('https://apps.limemotion.com/limemotion-video-tool/index.php',
      //     formData,
      //     {
      //       headers: {
      //         'Content-Type': 'multipart/form-data'
      //       },
      //       onUploadProgress: (e) => {
      //         console.log(e);
      //         if (e.lengthComputable) {
      //           //console.log(e.loaded / e.total * 100);
      //           self.uploadPercentage = (e.loaded / e.total * 100).toFixed(2);
      //         }
      //       }
      //     })
      //     .then(function (response) {
      //       console.log('SUCCESS!!', response.data);
      //       self.isUploading = false;
      //
      //
      //       if (response.data.status == 'success') {
      //         self.$emit('finished');
      //       } else {
      //         self.error = response.data.error;
      //       }
      //
      //     })
      //     .catch(function (e) {
      //       console.log('FAILURE!! ' + e);
      //       self.error = e;
      //     })
      //     .finally(() => {
      //       self.isUploading = false;
      //     })


      const metadata = {customMetadata: {...this.form, ...q}};

      const storageRef = fb.storage
          .ref(`media/${this.user.uid}_` + new Date().getTime() + '_video.webm')
          .put(videoFile, metadata);

      storageRef.on(`state_changed`, snapshot => {
            self.uploadPercentage = ((snapshot.bytesTransferred / snapshot.totalBytes) * 100).toFixed(2);
          }, error => {
            console.log(error.message);
            self.error = error.message;
          },
          () => {
            self.isUploading = false;
            self.$emit('finished');
          }
      );
    }
  }
}
</script>

<style>
.heart {
  animation: heart-pulse 0.9s infinite ease-out;
}

@keyframes heart-pulse {
  0% {
    transform: scale(0.8); /* scaling to 0 */
  }
  50% {
    transform: scale(1); /* increasing the size */
  }
  70% {
    transform: scale(1); /* decreasing the size */
  }
  100% {
    transform: scale(0.8); /* seeting back to initial size */
  }
}

.video-js > video {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
</style>
